import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'

import './HmoPolicyConcentDialog.css'

const HmoPolicyConcentDialog = () => {
  const dispatch = useDispatch()
  const isHmoPolicyConcentDialogVisible = useSelector(
    state => state.app.isHmoPolicyConcentDialogVisible
  )
  const userDetails = useSelector(state => state.profile?.userDetails)

  const onConsentAgreed = () => {
    dispatch(Actions.createAction(Actions.HMO_PRIVACY_CONCENT_AGREED))
    // in case there is already userDetails (user is logged in) we need to update the user consent
    // note - on signup we also call this dialog but we don't have userDetails yet so we are updating the concent after user signup
    // so we are not calling the update consent here
    if (userDetails) {
      dispatch(Actions.createAction(Actions.HMO_CONSENT_AGREEMENT_REQUESTED))
    }
  }

  return (
    <Dialog
      isVisible={isHmoPolicyConcentDialogVisible}
      className="consentHMO-dialog"
      keyboard={false}
      footerActions={[
        <Button key={'signup'} type="primary" onClick={onConsentAgreed}>
          {$t('dialogs.consentHMO.accept')}
        </Button>,
      ]}
      closable={false}
      maskClosable={false}
      onCancel={() =>
        dispatch(Actions.createAction(Actions.CLOSE_HMO_PRIVACY_CONCENT_DIALOG))
      }
    >
      <div className="consent-text">
        <div className="consent-note">{$t('dialogs.consentHMO.note')}</div>
        <h1 className="consent-title">{$t('dialogs.consentHMO.title')}</h1>
        <div className="consent-terms">{$t('dialogs.consentHMO.body')}</div>
      </div>
    </Dialog>
  )
}

export default HmoPolicyConcentDialog
